module.exports = __webpack_public_path__ + "static/media/six.5cd83005.svg";